import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import Keycloak, { KeycloakProfile } from 'keycloak-js';
import { ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly keycloak = inject(Keycloak);
  private readonly http = inject(HttpClient);

  private readonly userSubject = new ReplaySubject<KeycloakProfile>(1);
  user$ = this.userSubject.asObservable();

  constructor() {
    this.loadUserProfile();
  }

  private loadUserProfile() {
    this.keycloak.loadUserProfile().then((profile) => this.userSubject.next(profile));
  }

  login(): void {
    this.keycloak.login();
  }
  logout(): void {
    this.keycloak.logout();
  }

  getKeycloakId(): string {
    return this.keycloak.idTokenParsed?.sub ?? '';
  }
}
